// Modal.js
import { useEffect } from 'react';
import ReactDOM from 'react-dom';

export default ({ isOpen, onClose, children, heading = 'Modal Title', isHeading = true,modelClass="modal-lg" }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open');
      document.body.style.overflow = 'hidden';
    } else {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <>
      {/* Backdrop (z-index 1050) */}
      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} />

      {/* Modal (z-index 1055) */}
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 1055 }}
        onClick={onClose}
      >
        <div
          className={`modal-dialog modal-dialog-centered ${modelClass}`}
          role="document"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            {
              isHeading && <div className="modal-header">
                <h5 className="modal-title">
                  {heading}
                </h5>
                <button type="button" className="btn-close" onClick={onClose}></button>
              </div>
            }
            {
              isHeading?<div className="modal-body p-0">{children}</div>:<>{children}</>
            }

            
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

